import React, { useState } from 'react';

import { IconTypes } from '@eika/icon';

import { ActionButtonGroup } from '../../../components/shared/ActionButtonGroup';
import DemoModal from './DemoModal';

type Props = { className?: string; withCrossborder?: boolean };

const DemoActions: React.FC<Props> = ({ className, withCrossborder = false }) => {
    const [openDemoModal, setOpenDemoModal] = useState(false);
    const actions = [
        {
            children: 'Overfør',
            icon: IconTypes.OVERFOERE_36,
            onClick: () => setOpenDemoModal(true),
            'data-testid': 'transfer-demo-action',
        },
        {
            children: 'Betal',
            icon: IconTypes.BETALE_36,
            onClick: () => setOpenDemoModal(true),
            'data-testid': 'payment-demo-action',
        },
        ...(withCrossborder
            ? [
                  {
                      children: 'Betal til utlandet',
                      icon: IconTypes.JORDEN_36,
                      onClick: () => setOpenDemoModal(true),
                      'data-testid': 'crossborder-payment-demo-action',
                  },
              ]
            : []),
    ];
    return (
        <>
            <ActionButtonGroup className={className} actions={actions} />
            <DemoModal open={openDemoModal} setOpen={setOpenDemoModal} />
        </>
    );
};

export default DemoActions;
